var React = require('react');

function Lawyer (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Combined Shape (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M19.5031 8.07828L20.6244 6.95697L19.0004 5.33301L8.94732 15.3861L10.5713 17.0101L11.6926 15.8888L15.0952 19.2913L4.66992 29.7166L6.29388 31.3406L16.7191 20.9153L20.2628 24.4589L19.2326 25.489L20.8017 27.0581L30.8214 17.0384L29.2523 15.4694L28.0732 16.6484L19.5031 8.07828ZM21.7457 22.6939L26.3083 18.1314L17.8791 9.70224L13.3166 14.2648L21.7457 22.6939ZM35.255 31.7478L35.2492 34.0444L20.5859 34.0073L20.5917 31.7107L35.255 31.7478Z"}));
}

Lawyer.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Lawyer;

Lawyer.default = Lawyer;
